import React from 'react';

export function PaymentPage({location}) {
    const params = new URLSearchParams(location.search);
    return (
        <div className={'card card-custom pt-3'}>
            <div className={'card-header'}>
                <h2 className={'text-center'}>{params.get('status') === 'success' ? 'پرداخت با موفقیت انجام شد' : 'خطا هنگام پرداخت'}</h2>
            </div>
            <div className={'card-body'}>
                {params.get('status') === 'success' ? (
                    <>
                مبلغ
                {parseInt(params.get('amount')).toLocaleString()} ریال به حساب شما اضافه شد
                    </>
                    ) : (
                        <>
                    خطایی هنگام پرداخت رخ داد. لطفا دوباره امتحان کنید و در صورت بروز دوباره مشکل با پشتیبانی در ارتباط باشید.
                    </>
                    )}
            </div>
            <div className={'card-footer'}>
                <a href={"/user-profile/wallet"} type={'button'} className={'btn btn-primary'}>
                    بازگشت به کیف پول
                </a>
            </div>
        </div>
    )
}